module.exports = __webpack_public_path__ + "content/1df9c2295c3ffaca881116cfc03b9dfd.png";